import React from 'react';
import { useRouteParams } from '@/context/routeParamsContext';
import { useLoungeImportantInformation } from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { IconCircle, IconTriangle, IconSquare } from '../icons';

const LoungeImportantInformation = () => {
  const { lounges } = useCommonContent();
  const { loungeId } = useRouteParams();
  const importantInfo = useLoungeImportantInformation(loungeId);
  const isImportantInfoPresent =
    importantInfo?.general?.length > 0 ||
    importantInfo?.warning?.length > 0 ||
    importantInfo?.regulatory?.length > 0;

  if (!isImportantInfoPresent) {
    return null;
  }

  return (
    <div className="tw-mb-6 tw-border-b tw-border-gray-300 tw-pb-6">
      <h2 className="tw-heading-xs-bold tw-mb-4 tw-text-gray-900">
        {lounges?.importantInfo?.header}
      </h2>
      <ul className="tw-space-y-4">
        {importantInfo.general?.map((item, i) => (
          // eslint-disable-next-line react/no-array-index-key -- no other item to add as key
          <li key={`general-${i}`} className="tw-flex">
            <div className="tw-flex-shrink-0 tw-pr-2 tw-pt-1">
              <IconCircle className="tw-fill-green-600" />
            </div>
            {item}
          </li>
        ))}
        {importantInfo.warning?.map((item, i) => (
          // eslint-disable-next-line react/no-array-index-key -- no other item to add as key
          <li key={`warning-${i}`} className="tw-flex">
            <div className="tw-flex-shrink-0 tw-pr-2 tw-pt-1">
              <IconTriangle className="tw-fill-orange-600" />
            </div>
            {item}
          </li>
        ))}
        {importantInfo.regulatory?.map((item, i) => (
          // eslint-disable-next-line react/no-array-index-key -- no other item to add as key
          <li key={`regulatory-${i}`} className="tw-flex">
            <div className="tw-flex-shrink-0 tw-pr-2 tw-pt-1">
              <IconSquare className="tw-fill-red-600" />
            </div>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LoungeImportantInformation;
